export default {
    isLoggedIn: false,
    loggedUser: JSON.parse(localStorage.getItem('user')) || null
};
